/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */

$(document).ready(function() {
  $('body').on('click', '[name="checkout"], [name="goto_pp"], [name="goto_gc"]', function(event) {
    
    // console.log(this); // click event
    // event.preventDefault();
    //const form = $(this).parents('form:first');
    //console.log(form.serialize());
//     console.log(form);
    //form.submit(); // goes to cart page
//     console.log(event);
//     $(this).submit(); // this is button element
//     jQuery.getJSON('/cart.js', function(cart) {
//       // console.log(cart);
//       const modal = $('#login-modal').modal();
//       modal.on('click', '#modal-confirm', function(e) {
//         e.preventDefault();
//         $.modal.close();
//       });
//     });
// 	
    //return false;
  });
});